import $ from "cash-dom";

$(function () {
    const require_msg = '入力は必須です。';
    const email_msg = '正しいメールアドレスではありません。';

    const isEmpty = function (str) {
        return (!str || str.length === 0 );
    }

    const clearMessage = function () {
        $('.email-msg').html('');
        $('.password-msg').html('');
    }

    const validate = function () {
        const email = $('#email').val();
        const pass = $('#password').val();
        let hasError = false;
        if (isEmpty(email)) {
            $('.email-msg').html(require_msg);
            hasError = true;
        } else {
            const re = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            if (!re.test(email)) {
                $('.email-msg').html(email_msg);
                hasError = true;
            }
        }

        if (isEmpty(pass)) {
            $('.password-msg').html(require_msg);
            hasError = true;
        }

        return !hasError;
    };

    $('form').on('submit', function (event) {
        clearMessage();
        if (validate() === false) {
            event.preventDefault();
            return false;
        }

        return true;
    });

});
